
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class TheDefault extends Vue {
  @Prop() item!: string | null;
  @Prop() isCard!: any;
  @Prop() componentClass!: string | null;
}
